// extracted by mini-css-extract-plugin
export default {"loader":"Login_loader__B68h5","wrapper":"Login_wrapper__Q3rSQ"};